import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

// import {
// 	Message
// } from 'element-ui';
const includPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return includPush.call(this, location).catch((err) => err);
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(Router);

const createRouter = () =>
  new Router({
    mode: "history",
    routes: [
      {
        //官网根目录
        path: "/",
        redirect: "webIndex",
        component: () => import("@/views/webIndex/index.vue"),
        children: [
          {
            //首页
            path: "/webIndex",
            name: "webIndex",
            component: () => import("@/views/webIndex/webIndex.vue"),
          },
          {
            //中转路由
            path: "empty",
            name: "empty",
            component: () => import("@/views/webIndex/info/empty.vue"),
          },
          {
            // 搜索页
            path: "/search",
            name: "search",
            component: () => import("@/views/webIndex/search/search.vue"),
          },
          {
            // 通用资讯模板
            path: "/info",
            name: "info",
            component: () => import("@/views/webIndex/info/info.vue"),
            children: [
              {
                //列表
                path: "/info/list",
                name: "infolist",
                component: () => import("@/views/webIndex/info/infolist.vue"),
              },
              {
                //详情
                path: "/info/detail/:id",
                name: "detail",
                component: () => import("@/views/webIndex/info/infodetail.vue"),
                meta: {
                  title: "详情",
                },
              },
            ],
          },
          {
            //学习充电
            path: "/courseLearn",
            name: "courseLearn",
            component: () => import("@/views/webIndex/courseLearn.vue"),
          },
          {
            //充电视频详情
            path: "/videoplay",
            name: "videoplay",
            component: () => import("@/views/webIndex/videoplay.vue"),
          },
          {
            //入会须知
            path: "/admissionNotice",
            name: "admissionNotice",
            component: () => import("@/views/webIndex/admissionNotice.vue"),
          },
          {
            //奖项详情
            path: "/awardDetail/:id",
            name: "awardDetail",
            component: () => import("@/views/webIndex/awardDetail.vue"),
          },
          {
            //推荐资讯详情
            path: "/recomDetail/:id",
            name: "recomDetail",
            component: () => import("@/views/webIndex/recomDetail.vue"),
          },
          {
            //登录
            path: "/login",
            name: "login",
            component: () => import("@/views/webIndex/login.vue"),
          },
          {
            //注册
            path: "/register",
            name: "register",
            component: () => import("@/views/webIndex/register.vue"),
          },
          {
            //忘记密码
            path: "/forgetpassword",
            name: "forgetpassword",
            component: () => import("@/views/webIndex/forgetpassword.vue"),
          },
          {
            //会员校验
            path: "/vipcheck",
            name: "vipcheck",
            component: () => import("@/views/webIndex/vipcheck.vue"),
          },
          {
            // 业务平台-列表
            path: "/activitiesList",
            name: "activitiesList",
            component: () =>
              import("@/views/webIndex/businessPlatform/activitiesList.vue"),
          },
          {
            // 业务平台-详情
            path: "/activitiesDetail",
            name: "activitiesDetail",
            component: () =>
              import("@/views/webIndex/businessPlatform/activitiesDetail.vue"),
          },
          {
            path: "/ifirameView",
            name: "ifirameView",
            component: () => import("@/views/iframeView/iframe.vue"),
          },
        ],
      },
      {
        // 登录后
        // 个人系统
        path: "/home",
        redirect: "userinfo",
        component: () => import("@/views/userIndex/index.vue"),
        children: [
          {
            //个人信息
            path: "/userinfo",
            name: "userinfo",
            component: () => import("@/views/userIndex/userinfo.vue"),
            meta: {
              requireAuth: true,
              uid: 0,
            },
          },
          {
            // 缴费管理
            path: "/paymanage",
            name: "paymanage",
            component: () => import("@/views/userIndex/paymanage.vue"),
            meta: {
              requireAuth: true,
              uid: 1,
            },
          },
          {
            // 我要留言
            path: "/leave",
            name: "leave",
            component: () => import("@/views/userIndex/leave.vue"),
            meta: {
              requireAuth: true,
              uid: 2,
            },
          },
          
          {
            // 专业证书
            path: "/professionalCert",
            name: "professionalCert",
            component: () => import("@/views/userIndex/certIframe.vue"),
            meta: {
              requireAuth: true,
              uid: 6,
            },
          },
          
          {
            // 培训证书
            path: "/trainingCert",
            name: "trainingCert",
            component: () => import("@/views/userIndex/certIframe.vue"),
            meta: {
              requireAuth: true,
              uid: 7,
            },
          },

          {
            // 积分管理
            path: "/pointManagement",
            name: "pointManagement",
            component: () => import("@/views/userIndex/pointManagement.vue"),
            meta: {
              requireAuth: true,
              uid: 8,
            },
          },
          {
            // 专家评分
            path: "/userIframe",
            name: "userIframe",
            component: () => import("@/views/iframeView/iframe.vue"),
            meta: {
              requireAuth: true,
              uid: 7,
            },
          },
          {
            //信息变更 infoChange
            path: "/infoChange",
            name: "infoChange",
            component: () => import("@/views/userIndex/infoChange.vue"),
            meta: {
              requireAuth: true,
              uid: 3,
            },
          },
          {
            //信息变更详情
            path: "/changeDetail/:id",
            name: "changeDetail",
            component: () => import("@/views/userIndex/changeDetail.vue"),
            meta: {
              requireAuth: true,
              uid: 3,
            },
          },
          {
            // 会员证书
            path: "/certificate",
            name: "certificate",
            component: () => import("@/views/userIndex/certificate.vue"),
            meta: {
              requireAuth: true,
              uid: 4,
            },
          },
          {
            // 学习记录
            path: "/studyRecord",
            name: "studyRecord",
            component: () => import("@/views/userIndex/studyRecord.vue"),
            meta: {
              requireAuth: true,
              uid: 8,
            },
          },
          {
            // 修改手机号
            path: "/changephone",
            name: "changephone",
            component: () => import("@/views/userIndex/changephone.vue"),
            meta: {
              requireAuth: true,
            },
          },
          {
            // 修改密码
            path: "/changepassword",
            name: "changepassword",
            component: () => import("@/views/userIndex/changepassword.vue"),
            meta: {
              requireAuth: true,
              uid: 5,
            },
          },
          {
            path: "/noticeCenter",
            name: "noticeCenter",
            component: () => import("@/views/userIndex/noticeCenter.vue"),
            meta: {
              requireAuth: true,
            },
          },
        ],
      },
      {
        //会议报到
        path: "/activesSign",
        name: "activesSign",
        component: () => import("@/views/activities/activesSign.vue"),
        meta: {
          requireAuth: false,
          uid: 0,
        },
      },
      {
        //会议签到
        path: "/activesApply",
        name: "activesApply",
        component: () => import("@/views/activities/activesApply.vue"),
        meta: {
          requireAuth: false,
          uid: 0,
        },
      },
      {
        // 手机
        path: "/phone",
        redirect: "phoneIndex",
        component: () => import("@/views/phoneIndex/index.vue"),
        children: [
          {
            //个人信息
            path: "/oneIndex",
            redirect: "phoneIndex",
            component: () => import("@/views/phoneIndex/phoneIndex.vue"),
            children: [
              {
                path: "/phoneIndex",
                name: "phoneIndex",
                component: () => import("@/views/webIndex/webIndex.vue"),
                meta: {
                  uid: 0,
                },
              },
              {
                //中转路由
                path: "/phoneIndex/empty",
                name: "phoneEmpty",
                component: () => import("@/views/webIndex/info/empty.vue"),
              },
              {
                // 通用资讯模板
                path: "/phoneIndex/info",
                name: "phoneInfo",
                component: () => import("@/views/webIndex/info/info.vue"),
                children: [
                  {
                    //列表
                    path: "/phoneIndex/info/list",
                    name: "phoneInfolist",
                    component: () =>
                      import("@/views/webIndex/info/infolist.vue"),
                    meta: {
                      uid: 0,
                    },
                  },
                  {
                    //详情
                    path: "/phoneIndex/info/detail/:id",
                    name: "phoneDetail",
                    component: () =>
                      import("@/views/webIndex/info/infodetail.vue"),
                    meta: {
                      title: "详情",
                      uid: 0,
                    },
                  },
                ],
              },
              {
                //学习充电
                path: "/phoneIndex/courseLearn",
                name: "phoneCourseLearn",
                component: () => import("@/views/webIndex/courseLearn.vue"),
              },
              {
                // 我要留言
                path: "/phoneIndex/leave",
                name: "phoneLeave",
                component: () => import("@/views/userIndex/leave.vue"),
                meta: {
                  requireAuth: true,
                },
              },
              {
                //充电视频详情-手机
                path: "/phoneIndex/videoplay",
                name: "phoneVideoplay",
                component: () => import("@/views/webIndex/videoplay.vue"),
              },
              {
                //入会须知
                path: "/phoneIndex/admissionNotice",
                name: "phoneAdmissionNotice",
                component: () => import("@/views/webIndex/admissionNotice.vue"),
                meta: {
                  uid: 0,
                },
              },
              {
                //奖项详情
                path: "/phoneIndex/awardDetail/:id",
                name: "awardDetail",
                component: () => import("@/views/webIndex/awardDetail.vue"),
                meta: {
                  uid: 0,
                },
              },
              {
                //推荐资讯详情
                path: "/phoneIndex/recomDetail/:id",
                name: "recomDetail",
                component: () => import("@/views/webIndex/recomDetail.vue"),
                meta: {
                  uid: 0,
                },
              },
              {
                //登录
                path: "/phoneIndex/login",
                name: "phoneLogin",
                component: () => import("@/views/webIndex/login.vue"),
                meta: {
                  uid: 0,
                },
              },
              {
                //注册
                path: "/phoneIndex/register",
                name: "phoneRegister",
                component: () => import("@/views/webIndex/register.vue"),
                meta: {
                  uid: 0,
                },
              },
              {
                //忘记密码
                path: "/phoneIndex/forgetpassword",
                name: "phoneForgetpassword",
                component: () => import("@/views/webIndex/forgetpassword.vue"),
                meta: {
                  uid: 0,
                },
              },
              {
                //会员校验
                path: "/phoneIndex/vipcheck",
                name: "phoneVipcheck",
                component: () => import("@/views/webIndex/vipcheck.vue"),
                meta: {
                  uid: 0,
                },
              },
              {
                // 业务平台-列表-手机
                path: "/phoneActivitiesList",
                name: "phoneActivitiesList",
                component: () =>
                  import(
                    "@/views/webIndex/businessPlatform/activitiesList.vue"
                  ),
              },
              {
                // 业务平台-详情-手机
                path: "/phoneActivitiesDetail",
                name: "phoneActivitiesDetail",
                component: () =>
                  import(
                    "@/views/webIndex/businessPlatform/activitiesDetail.vue"
                  ),
              },
            ],
          },
          {
            // 服务
            path: "/service",
            redirect: "phoneService",
            component: () => import("@/views/phoneIndex/service.vue"),
            children: [
              {
                //我的首页
                path: "/phoneService",
                name: "phoneService",
                component: () => import("@/views/phoneIndex/phoneService.vue"),
                meta: {
                  requireAuth: true,
                  uid: 1,
                },
              },
              {
                //缴费管理
                path: "/phoneService/phonepaymanage",
                name: "phonePaymanage",
                component: () => import("@/views/userIndex/paymanage.vue"),
                meta: {
                  requireAuth: true,
                  uid: 1,
                },
              },
              {
                // 信息变更
                path: "/phoneService/phoneInfoChange",
                name: "phoneInfoChange",
                component: () => import("@/views/userIndex/infoChange.vue"),
                meta: {
                  requireAuth: true,
                  uid: 1,
                },
              },
              {
                // 变更详情
                path: "/phoneService/phoneChangeDetail/:id",
                name: "phoneChangeDetail",
                component: () => import("@/views/userIndex/changeDetail.vue"),
                meta: {
                  requireAuth: true,
                  uid: 1,
                },
              },
              {
                // 会员证书
                path: "/phoneService/phoneCertificate",
                name: "phoneCertificate",
                component: () => import("@/views/userIndex/certificate.vue"),
                meta: {
                  requireAuth: true,
                  uid: 1,
                },
              },
            ],
          },
          {
            //我的
            path: "/My",
            redirect: "phoneMy",
            component: () => import("@/views/phoneIndex/my.vue"),
            children: [
              {
                //我的首页
                path: "/phoneMy",
                name: "phoneMy",
                component: () => import("@/views/phoneIndex/phoneMy.vue"),
                meta: {
                  requireAuth: true,
                  uid: 2,
                },
              },
              {
                //消息中心
                path: "/phoneMy/phoneNotice",
                name: "phoneNotice",
                component: () => import("@/views/userIndex/noticeCenter.vue"),
                meta: {
                  requireAuth: true,
                  uid: 2,
                },
              },
              {
                // 修改密码
                path: "/phoneMy/phonePassword",
                name: "phonePassword",
                component: () => import("@/views/userIndex/changepassword.vue"),
                meta: {
                  requireAuth: true,
                  uid: 2,
                },
              },
              {
                // 基本信息
                path: "/phoneMy/phoneBasic",
                name: "phoneBasic",
                component: () => import("@/views/phoneIndex/phoneBasic.vue"),
                meta: {
                  requireAuth: true,
                  uid: 2,
                },
              },
              {
                // 证书信息
                path: "/phoneMy/phoneCertInfo",
                name: "phoneCertInfo",
                component: () => import("@/views/phoneIndex/phoneCertInfo.vue"),
                meta: {
                  requireAuth: true,
                  uid: 2,
                },
              },
            ],
          },
        ],
      },
    ],
  });

const router = createRouter();

router.beforeEach((to, from, next) => {
  // 打开项目根网站，判断设备
  if (to.redirectedFrom == "/") {
    if (window.screen.width < 760) {
      next("/phoneIndex");
    } else {
      next("/webIndex");
    }
  } else {
    if (to.meta.requireAuth) {
      //判断该路由是否需要登录权限
      if (store.state.user.token) {
        //通过浏览器本地缓存判断当前的token是否存在
        next();
      } else {
        if (from.fullPath == "/login") {
          next("/");
        } else {
          if (window.screen.width < 760) {
            if (from.name != "phoneLogin") {
              next({
                path: "/phoneIndex/login",
              });
            }
          } else {
            next({
              path: "/login",
            });
          }
        }
      }
    } else {
      next();
    }
  }
});

export default router;
